export default class Accordion {
	constructor(id) {
		this.id = id;
		this.$root = null;
		this.$cardCollection = null;

		this.init();
	}

	init() {
		this.getElements();
		this.addItemCollapsingHandler();
	}

	getElements() {
		this.$root = document.getElementById(this.id);

		if (!this.$root) return;

		this.$cardCollection = this.$root.querySelectorAll('.accordion_card');
	}

	addItemCollapsingHandler() {
		if (!this.$cardCollection) return;

		this.$cardCollection.forEach($card => {
			if (!$card.querySelector('.accordion_collapse')) return;

			$card.addEventListener('click', e => {
				const $header = e.target.closest('.accordion_card-header');
				const $targetedCard = $header ? $header.closest('.accordion_card') : null;

				this.closeOpened($targetedCard);
				this.toggle($card);
			});
		});
	}

	closeAllAndOpen($card) {
		if (!this.$root) return;

		const $openedCardCollection = this.$root.querySelectorAll('.accordion_card.-opened');
		$openedCardCollection.forEach($openedCard => {
			const $collapsed = $openedCard.querySelector('.accordion_collapse');
			this.close($openedCard, $collapsed);
		});

		const $collapsed = $card.querySelector('.accordion_collapse');
		this.open($card, $collapsed);
	}

	toggle($card) {
		if (!$card) return;

		const $collapsed = $card.querySelector('.accordion_collapse');

		if (!$collapsed.style.maxHeight) {
			this.open($card, $collapsed);
		} else {
			this.close($card, $collapsed);
		}
	}

	open($card, $collapsed) {
		if (!$card && !$collapsed) return;

		const $cardBody = $collapsed.querySelector('.accordion_card-body');
		const cardHeight = $cardBody.offsetHeight;
		$collapsed.style.maxHeight = cardHeight + 'px';
		$card.classList.add('-opened');
	}

	close($card, $collapsed) {
		if (!$card && !$collapsed) return;

		$collapsed.style.maxHeight = null;
		$card.classList.remove('-opened');
	}

	closeOpened($targetedCard) {
		if (!$targetedCard && !this.$root) return;

		const $openedCardCollection = this.$root.querySelectorAll('.accordion_card.-opened');
		$openedCardCollection.forEach($card => {
			if ($card !== $targetedCard) {
				const $collapsed = $card.querySelector('.accordion_collapse');
				this.close($card, $collapsed);
			}
		});
	}
}